var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import SaleProcessTable, { ERoleID, } from "@frameworks/salesjourney/components/Generic/SaleProcessTable";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Row, Col } from "react-bootstrap";
import UpcomingActivities from "./UpcomingActivities";
import di from "../di/index";
import { useSelector } from "react-redux";
import nrdi from "@frameworks/salesjourney/components/Features/RevenueDashBoard/di/serviceLocator";
import * as moment from "moment";
import { EnumSalesFilter, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import { base64toExcel } from "@frameworks/salesjourney/utils/genericMethods";
import { getDateInFormat } from "@domains/utils/reportDates";
import ReportValue from "../../../../shared-library/components/commonTableVal";
import { useNavigate } from "react-router-dom";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import summarize from "@domains/utils/summarize";
import CriticalActivities from "./CriticalActivities";
import profileDi from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { Link } from "react-router-dom";
import GenericTabs from "../../../../shared-library/components/GenericTabs";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import { GenericDropdown } from "../../../../shared-library/components/GenericDropdown";
import filteDi from "@frameworks/salesjourney/components/filterDi/serviceLocator";
export var ETableTabs;
(function (ETableTabs) {
    ETableTabs["Meeting_Summary"] = "Meeting_Summary";
    ETableTabs["Lead_Summary"] = "Lead_Summary";
    ETableTabs["Revenue_Summary"] = "Revenue_Summary";
})(ETableTabs || (ETableTabs = {}));
export var EPipelineSummaryColumns;
(function (EPipelineSummaryColumns) {
    EPipelineSummaryColumns["TotalClientPartner"] = "Partner + Client";
    EPipelineSummaryColumns["Partner"] = "Partner";
    EPipelineSummaryColumns["Remaining"] = "Remaining";
    EPipelineSummaryColumns["NotConverted"] = "Not Converted";
    EPipelineSummaryColumns["ClientTotal"] = "Client Total";
    EPipelineSummaryColumns["InprocessPipeline"] = "Inprocess Pipeline";
    EPipelineSummaryColumns["NotConvertedPipeline"] = "Not Converted Pipeline";
    EPipelineSummaryColumns["Expired"] = "Expired";
    EPipelineSummaryColumns["ConvertedPipeline"] = "Converted Pipeline";
    EPipelineSummaryColumns["OrderValue"] = "Order Value";
})(EPipelineSummaryColumns || (EPipelineSummaryColumns = {}));
var HomeSalesTable = forwardRef(function (_a, ref) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var finalFilterState = _a.finalFilterState, showWeek = _a.showWeek;
    var navigate = useNavigate();
    var engagementCommaValue = function (key, row, columnkey, isClick, index, showSummarize) {
        // console.log(
        //   "engagement row",
        //   row,
        //   columnkey,
        //   isClick,
        //   index,
        //   showSummarize
        // );
        return (React.createElement("div", null,
            React.createElement(ReportValue, { val: key, stream: false, onlyval: true, withoutDigit: true, showZero: false, showSummarize: showSummarize })));
    };
    var _m = __read(useState(false), 2), downloadEngagementLoader = _m[0], setDownloadEngagementLoader = _m[1];
    var _o = __read(useState(false), 2), downloadLeadsLoader = _o[0], setDownloadLeadsLoader = _o[1];
    var _p = __read(useState(false), 2), downloadNRLoader = _p[0], setDownloadNRLoader = _p[1];
    var _q = __read(React.useState(true), 2), toggleCheck = _q[0], setToggleCheck = _q[1];
    var _r = __read(React.useState(), 2), summarizedData = _r[0], setSummarizedData = _r[1];
    var _s = __read(React.useState({
        title: "FTM",
        value: "FTM",
    }), 2), dropDownNRSelected = _s[0], setDropDownNRSelected = _s[1];
    var _t = __read(useState([]), 2), pipelineSummaryItemList = _t[0], setPipelineSummaryItemList = _t[1];
    var _u = __read(useState({
        title: "Client & Partner",
        value: "3",
    }), 2), pipelineSummarySelectedItem = _u[0], setPipelineSummarySelectedItem = _u[1];
    var _v = __read(React.useState(true), 2), init = _v[0], setInit = _v[1];
    var _w = __read(React.useState(ETableTabs.Meeting_Summary), 2), selectedTab = _w[0], setSelectedTab = _w[1];
    var engagementColumn = [
        { name: "Type", key: "type" },
        {
            name: "Meeting",
            key: "meeting",
            tdCustomFunction: engagementCommaValue,
        },
        {
            name: "Virtual",
            key: "virtual",
            tdCustomFunction: engagementCommaValue,
        },
        {
            name: "Calling",
            key: "calling",
            tdCustomFunction: engagementCommaValue,
        },
    ];
    var FTMCommaValue = function (key, row, columnkey, isClick, index, showSummarize, isAnotherKey, subRow, colKey1, colKey2) {
        var navigateURL = function () {
            var _a, _b, _c, _d;
            var localFinalFilterState = {};
            if (isClick && parseInt(key) > 0) {
                // let localFinalFilterState = JSON.parse(
                //   JSON.stringify(finalFilterState)
                // );
                if ((row === null || row === void 0 ? void 0 : row.productId) !== null && (row === null || row === void 0 ? void 0 : row.productId) !== undefined && (row === null || row === void 0 ? void 0 : row.productId) > 0) {
                    localFinalFilterState.productId = [row === null || row === void 0 ? void 0 : row.productId];
                    localFinalFilterState.productIdLst = [];
                    localFinalFilterState.productIdLst.push({
                        id: row === null || row === void 0 ? void 0 : row.productId,
                        parentFilter: EnumSalesFilter.productId,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.productIdLst,
                        name: row === null || row === void 0 ? void 0 : row.type,
                    });
                    localFinalFilterState.categoryIdLst = [];
                    if ((row === null || row === void 0 ? void 0 : row.data) &&
                        ((_a = row === null || row === void 0 ? void 0 : row.data) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        ((_b = row === null || row === void 0 ? void 0 : row.data[index]) === null || _b === void 0 ? void 0 : _b.categoryId) > 0 &&
                        ((_c = row === null || row === void 0 ? void 0 : row.data[index]) === null || _c === void 0 ? void 0 : _c.isCategory) &&
                        subRow !== null &&
                        subRow !== undefined &&
                        subRow) {
                        var strName = encodeURIComponent((_d = row === null || row === void 0 ? void 0 : row.data[index]) === null || _d === void 0 ? void 0 : _d.type);
                        console.log("strNa,e", strName);
                        // strName=strName.replace("&","");
                        localFinalFilterState.categoryId = [row === null || row === void 0 ? void 0 : row.data[index].categoryId];
                        localFinalFilterState.categoryIdLst.push({
                            id: row === null || row === void 0 ? void 0 : row.data[index].categoryId,
                            parentFilter: EnumSalesFilter.categoryId,
                            checked: true,
                            inputType: "checkbox",
                            filterKey: EnumSalesFilter.categoryIdLst,
                            name: strName,
                        });
                    }
                    localFinalFilterState.statusLst = [];
                    if (colKey1 !== undefined &&
                        colKey1 !== null &&
                        colKey1 !== "" &&
                        colKey1 === "totalPipeline") {
                        localFinalFilterState.searchFlagNew = "allcp";
                    }
                    else if (colKey1 !== undefined &&
                        colKey1 !== null &&
                        colKey1 !== "" &&
                        (colKey1 === "pipeline" || colKey1 === "partnerPipeline")) {
                        localFinalFilterState.status = [
                            leadStatusConfig.openStatusIdForLeadFilter,
                            leadStatusConfig.inProcessStatusIdForLeadFilter,
                            leadStatusConfig.convertedStatusIdForLeadFilter,
                            leadStatusConfig.nonConvertedStatusIdForLeadFilter,
                        ];
                        if (colKey1 === "partnerPipeline") {
                            localFinalFilterState.searchFlagNew = "allp";
                        }
                        else
                            localFinalFilterState.searchFlagNew = "all";
                    }
                    else if (colKey1 !== undefined &&
                        colKey1 !== null &&
                        colKey1 !== "" &&
                        (colKey1 === "inprocess" || colKey1 === "partnerInProcess")) {
                        localFinalFilterState.status = [leadStatusConfig.inProcessStatusIdForLeadFilter];
                        localFinalFilterState.statusLst = [
                            {
                                id: leadStatusConfig.inProcessStatusIdObject.id,
                                parentFilter: EnumSalesFilter.status,
                                checked: true,
                                inputType: "checkbox",
                                filterKey: EnumSalesFilter.statusLst,
                                name: leadStatusConfig.inProcessStatusIdObject.name,
                            },
                        ];
                        if (colKey1 === "partnerInProcess") {
                            localFinalFilterState.searchFlagNew = "inprocessp";
                        }
                        else
                            localFinalFilterState.searchFlagNew = "inprocess";
                    }
                    else if (colKey1 !== undefined &&
                        colKey1 !== null &&
                        colKey1 !== "" &&
                        colKey1 === "remainingPartnerPipeline") {
                        localFinalFilterState.searchFlagNew = "remainingp";
                    }
                    else if (colKey1 !== undefined &&
                        colKey1 !== null &&
                        colKey1 !== "" &&
                        (colKey1 === "notConverted" || colKey1 === "partnerNotConverted")) {
                        localFinalFilterState.status = [leadStatusConfig.nonConvertedStatusIdForLeadFilter];
                        localFinalFilterState.statusLst = [
                            {
                                id: leadStatusConfig.notConvertedStatusIdObject.id,
                                parentFilter: EnumSalesFilter.status,
                                checked: true,
                                inputType: "checkbox",
                                filterKey: EnumSalesFilter.statusLst,
                                name: leadStatusConfig.notConvertedStatusIdObject.name,
                            },
                        ];
                        if (colKey1 === "partnerNotConverted") {
                            localFinalFilterState.searchFlagNew = "notconvertedp";
                        }
                        else
                            localFinalFilterState.searchFlagNew = "notconverted";
                    }
                    else if (colKey1 !== undefined &&
                        colKey1 !== null &&
                        colKey1 !== "" &&
                        (colKey1 === "order" || colKey1 === "partnerConveted")) {
                        localFinalFilterState.status = [leadStatusConfig.convertedStatusIdForLeadFilter];
                        localFinalFilterState.statusLst = [
                            {
                                id: leadStatusConfig.convertedStatusIdObject.id,
                                parentFilter: EnumSalesFilter.status,
                                checked: true,
                                inputType: "checkbox",
                                filterKey: EnumSalesFilter.statusLst,
                                name: leadStatusConfig.convertedStatusIdObject.name,
                            },
                        ];
                        if (colKey1 === "partnerConveted") {
                            localFinalFilterState.searchFlagNew = "convertp";
                        }
                        else
                            localFinalFilterState.searchFlagNew = "converted";
                    }
                    else if (colKey1 !== undefined &&
                        colKey1 !== null &&
                        colKey1 !== "" &&
                        colKey1 === "expired") {
                        localFinalFilterState.expiryId = "4";
                        localFinalFilterState.searchFlagNew = "expired";
                    }
                    // console.log("finalFilterList", finalFilterState, key);
                    localFinalFilterState.Participant = [
                        leadStatusConfig.leadOwnerFilterSourceObj.id,
                        leadStatusConfig.primaryOwnerFilterSource.id,
                    ];
                    localFinalFilterState.searchFlag = "pipelinesummary";
                    var skipUpdateUrl = true;
                    var url = URLConfig.config.applicationFolder +
                        "dashboard/lead-dashboard?filterData=" +
                        encodeURI(JSON.stringify(localFinalFilterState)) +
                        "&isShowWeek=" +
                        showWeek +
                        "&tabFlag=" +
                        0 +
                        "&skipUpdateUrl=" +
                        skipUpdateUrl;
                    return url;
                }
                else {
                    localFinalFilterState.productId = [];
                    localFinalFilterState.categoryId = [];
                    var url = URLConfig.config.applicationFolder +
                        "dashboard/lead-dashboard?filterData=" +
                        encodeURI(JSON.stringify(localFinalFilterState)) +
                        "&isShowWeek=" +
                        showWeek +
                        "&tabFlag=" +
                        0;
                    return url;
                }
            }
        };
        return (React.createElement("a", { className: parseInt(key) > 0
                ? isClick && parseInt(key) > 0
                    ? "hand_cursor common-link-child text-decoration-underline "
                    : "common-link-child"
                : "txt_black", href: navigateURL() },
            React.createElement(ReportValue, { val: key, stream: false, onlyval: true, withoutDigit: true, showZero: false, showSummarize: showSummarize }),
            isAnotherKey !== null &&
                isAnotherKey !== undefined &&
                (isAnotherKey === null || isAnotherKey === void 0 ? void 0 : isAnotherKey.toString()) !== "0" && (React.createElement(React.Fragment, null,
                "\u00A0(",
                React.createElement(ReportValue, { val: isAnotherKey, stream: false, onlyval: true, withoutDigit: true, showZero: false, showSummarize: showSummarize }),
                ")"))));
    };
    var getFtmColumns = function () {
        var ftmColumns = [
            { name: "Asset Type", key: "type" },
            {
                name: "Client Total",
                key: "pipeline",
                key2: "pipelineCount",
                tdCustomFunction: FTMCommaValue,
            },
            {
                name: "Inprocess Pipeline",
                key: "inprocess",
                key2: "inprocessCount",
                tdCustomFunction: FTMCommaValue,
            },
            {
                name: "Not Converted Pipeline",
                key: "notConverted",
                key2: "notConvertedCount",
                tdCustomFunction: FTMCommaValue,
            },
            {
                name: "Expired",
                key: "expired",
                key2: "expiredCount",
                tdCustomFunction: FTMCommaValue,
            },
            {
                name: "Converted Pipeline",
                key: "order",
                key2: "orderValueCount",
                tdCustomFunction: FTMCommaValue,
            },
            {
                name: "Order Value",
                key: "realised",
                key2: "realisedCount",
                notClickable: false,
                tdCustomFunction: FTMCommaValue,
            },
        ];
        if ((pipelineSummarySelectedItem === null || pipelineSummarySelectedItem === void 0 ? void 0 : pipelineSummarySelectedItem.value) == ERoleID.Client) {
            ftmColumns = [
                { name: "Asset Type", key: "type" },
                {
                    name: "Client Total",
                    key: "pipeline",
                    key2: "pipelineCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Inprocess Pipeline",
                    key: "inprocess",
                    key2: "inprocessCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Not Converted Pipeline",
                    key: "notConverted",
                    key2: "notConvertedCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Expired",
                    key: "expired",
                    key2: "expiredCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Converted Pipeline",
                    key: "order",
                    key2: "orderValueCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Order Value",
                    key: "realised",
                    key2: "realisedCount",
                    notClickable: false,
                    tdCustomFunction: FTMCommaValue,
                },
            ];
        }
        else if ((pipelineSummarySelectedItem === null || pipelineSummarySelectedItem === void 0 ? void 0 : pipelineSummarySelectedItem.value) == ERoleID.Partner) {
            ftmColumns = [
                { name: "Asset Type", key: "type" },
                {
                    name: "Partner Total",
                    key: "partnerPipeline",
                    key2: "partnerPipelineCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Remaining",
                    key: "remainingPartnerPipeline",
                    key2: "remainingPartnerPipelineCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Not Converted",
                    key: "partnerNotConverted",
                    key2: "partnerNotConvertedCount",
                    tdCustomFunction: FTMCommaValue,
                },
            ];
        }
        else {
            ftmColumns = [
                { name: "Asset Type", key: "type" },
                {
                    name: "Partner + Client",
                    key: "totalPipeline",
                    key2: "totalClient",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Partner",
                    key: "partnerPipeline",
                    key2: "partnerPipelineCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Remaining",
                    key: "remainingPartnerPipeline",
                    key2: "remainingPartnerPipelineCount",
                    tdCustomFunction: FTMCommaValue,
                },
                // {
                //   name: "In Process",
                //   key: "partnerInProcess",
                //   key2: "partnerInProcessCount",
                //   tdCustomFunction: FTMCommaValue,
                // },
                {
                    name: "Not Converted",
                    key: "partnerNotConverted",
                    key2: "partnerNotConvertedCount",
                    tdCustomFunction: FTMCommaValue,
                },
                // {
                //   name: "Converted",
                //   key: "partnerConveted",
                //   key2: "partnerConvetedCount",
                //   tdCustomFunction: FTMCommaValue,
                // },
                {
                    name: "Client Total",
                    key: "pipeline",
                    key2: "pipelineCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Inprocess Pipeline",
                    key: "inprocess",
                    key2: "inprocessCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Not Converted Pipeline",
                    key: "notConverted",
                    key2: "notConvertedCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Expired",
                    key: "expired",
                    key2: "expiredCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Converted Pipeline",
                    key: "order",
                    key2: "orderValueCount",
                    tdCustomFunction: FTMCommaValue,
                },
                {
                    name: "Order Value",
                    key: "realised",
                    key2: "realisedCount",
                    notClickable: false,
                    tdCustomFunction: FTMCommaValue,
                },
            ];
        }
        // if (!loginDI.login.getIsRMPartnerFRM().isRM) {
        //   ftmColumns = [
        //     { name: "Asset Type", key: "type" },
        //     {
        //       name: "Partner + Client",
        //       key: "totalPipeline",
        //       key2: "totalClient",
        //       tdCustomFunction: FTMCommaValue,
        //     },
        //     {
        //       name: "Partner",
        //       key: "partnerPipeline",
        //       key2: "partnerPipelineCount",
        //       tdCustomFunction: FTMCommaValue,
        //     },
        //     {
        //       name: "Remaining",
        //       key: "remainingPartnerPipeline",
        //       key2: "remainingPartnerPipelineCount",
        //       tdCustomFunction: FTMCommaValue,
        //     },
        //     // {
        //     //   name: "In Process",
        //     //   key: "partnerInProcess",
        //     //   key2: "partnerInProcessCount",
        //     //   tdCustomFunction: FTMCommaValue,
        //     // },
        //     {
        //       name: "Not Converted",
        //       key: "partnerNotConverted",
        //       key2: "partnerNotConvertedCount",
        //       tdCustomFunction: FTMCommaValue,
        //     },
        //     // {
        //     //   name: "Converted",
        //     //   key: "partnerConveted",
        //     //   key2: "partnerConvetedCount",
        //     //   tdCustomFunction: FTMCommaValue,
        //     // },
        //     {
        //       name: "Client Total",
        //       key: "pipeline",
        //       key2: "pipelineCount",
        //       tdCustomFunction: FTMCommaValue,
        //     },
        //     {
        //       name: "Inprocess Pipeline",
        //       key: "inprocess",
        //       key2: "inprocessCount",
        //       tdCustomFunction: FTMCommaValue,
        //     },
        //     {
        //       name: "Not Converted Pipeline",
        //       key: "notConverted",
        //       key2: "notConvertedCount",
        //       tdCustomFunction: FTMCommaValue,
        //     },
        //     {
        //       name: "Expired",
        //       key: "expired",
        //       key2: "expiredCount",
        //       tdCustomFunction: FTMCommaValue,
        //     },
        //     {
        //       name: "Converted Pipeline",
        //       key: "order",
        //       key2: "orderValueCount",
        //       tdCustomFunction: FTMCommaValue,
        //     },
        //     {
        //       name: "Order Value",
        //       key: "realised",
        //       key2: "realisedCount",
        //       notClickable: false,
        //       tdCustomFunction: FTMCommaValue,
        //     },
        //   ];
        // }
        return ftmColumns;
    };
    var ftmColumn = getFtmColumns();
    var CommaValue = function (key, row, columnkey, isClick, index, showSummarize, isAnotherKey, subRow, colKey1, colKey2, subRowIndex, subRowData) {
        function ontextClick() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            if (isClick && parseInt(key) > 0) {
                var getStatusId = null, getStatusName = void 0;
                var isClosed = "";
                var localFinalFilterState = {};
                if (columnkey === "open") {
                    getStatusId = [leadStatusConfig.openStatusIdForLeadFilter];
                    isClosed = "N";
                    getStatusName = leadStatusConfig.openStatusIdObject.name;
                }
                if (columnkey === "process") {
                    getStatusId = [leadStatusConfig.inProcessStatusIdForLeadFilter];
                    isClosed = "N";
                    getStatusName = leadStatusConfig.inProcessStatusIdObject.name;
                }
                if (columnkey === "conv") {
                    isClosed = "Y";
                    getStatusId = [leadStatusConfig.convertedStatusIdForLeadFilter];
                    getStatusName = leadStatusConfig.convertedStatusIdObject.name;
                }
                if (columnkey === "notconv") {
                    isClosed = "Y";
                    getStatusName = leadStatusConfig.notConvertedStatusIdObject.name;
                    getStatusId = [leadStatusConfig.nonConvertedStatusIdForLeadFilter];
                    localFinalFilterState.searchFlagNew = "leadsummarync";
                }
                if (columnkey === "expired") {
                    isClosed = "N";
                    getStatusId = [];
                    localFinalFilterState.expiryId = "4";
                }
                if (((_a = row === null || row === void 0 ? void 0 : row.data) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = row === null || row === void 0 ? void 0 : row.data[index]) === null || _b === void 0 ? void 0 : _b.productId)) {
                    localFinalFilterState.productIdLst = [];
                    localFinalFilterState.statusLst = [];
                    localFinalFilterState.productId = [row === null || row === void 0 ? void 0 : row.data[index].productId];
                    localFinalFilterState.status = getStatusId;
                    localFinalFilterState.searchFlag = "leadsummary";
                    localFinalFilterState.productIdLst.push({
                        id: row === null || row === void 0 ? void 0 : row.data[index].productId,
                        parentFilter: EnumSalesFilter.productId,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.productIdLst,
                        name: row === null || row === void 0 ? void 0 : row.data[index].type,
                    });
                    if (subRowIndex !== null && subRowIndex !== undefined) {
                        localFinalFilterState.categoryId = [(_d = (_c = row === null || row === void 0 ? void 0 : row.data[index]) === null || _c === void 0 ? void 0 : _c.data[subRowIndex]) === null || _d === void 0 ? void 0 : _d.categoryId];
                        if (((_f = (_e = row === null || row === void 0 ? void 0 : row.data[index]) === null || _e === void 0 ? void 0 : _e.data[subRowIndex]) === null || _f === void 0 ? void 0 : _f.categoryId) !==
                            (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.investmentProductIdObj.id)) {
                            localFinalFilterState.categoryIdLst = [
                                {
                                    id: (_h = (_g = row === null || row === void 0 ? void 0 : row.data[index]) === null || _g === void 0 ? void 0 : _g.data[subRowIndex]) === null || _h === void 0 ? void 0 : _h.categoryId,
                                    parentFilter: EnumSalesFilter.categoryId,
                                    checked: true,
                                    inputType: "checkbox",
                                    filterKey: EnumSalesFilter.categoryIdLst,
                                    name: (_k = (_j = row === null || row === void 0 ? void 0 : row.data[index]) === null || _j === void 0 ? void 0 : _j.data[subRowIndex]) === null || _k === void 0 ? void 0 : _k.type,
                                },
                            ];
                        }
                        else {
                            localFinalFilterState.categoryIdLst = [];
                        }
                    }
                    if (getStatusId !== null && getStatusId !== undefined && (getStatusId === null || getStatusId === void 0 ? void 0 : getStatusId.length) > 0)
                        localFinalFilterState.statusLst.push({
                            id: getStatusId[0],
                            parentFilter: EnumSalesFilter.status,
                            checked: true,
                            inputType: "checkbox",
                            filterKey: EnumSalesFilter.statusLst,
                            name: getStatusName,
                        });
                }
                else {
                    localFinalFilterState.productId = [];
                    localFinalFilterState.status = [];
                }
                var skipUpdateUrl = false;
                if (((_l = localFinalFilterState.productId) === null || _l === void 0 ? void 0 : _l.length) > 0 &&
                    ((_m = localFinalFilterState.status) === null || _m === void 0 ? void 0 : _m.length) > 0) {
                    skipUpdateUrl = true;
                }
                var newUrl = "/dashboard/lead-dashboard";
                var search = "filterData=" +
                    encodeURI(JSON.stringify(localFinalFilterState)) +
                    "&isShowWeek=" +
                    showWeek +
                    "&tabFlag=" +
                    0 +
                    "&closed=" +
                    isClosed +
                    "&skipUpdateUrl=" +
                    skipUpdateUrl;
                return { pathname: newUrl, search: search };
            }
            else
                return { pathname: "", search: "" };
        }
        return (React.createElement(Link, { className: parseInt(key) > 0
                ? isClick && parseInt(key) > 0
                    ? "hand_cursor common-link-child text-decoration-underline "
                    : "common-link-child"
                : "common-link-child", to: ontextClick() },
            React.createElement(ReportValue, { val: key, stream: false, onlyval: true, withoutDigit: true, showZero: false })));
    };
    var leadColumn = [
        { name: "Type", key: "type", tooltipText: "p1" },
        {
            name: "Open",
            key: "open",
            tdCustomFunction: CommaValue,
            tooltipText: "New lead created, but meeting yet to happen",
        },
        {
            name: "In Process",
            key: "process",
            tdCustomFunction: CommaValue,
            tooltipText: "Follow up meetings in progress",
        },
        {
            name: "Converted",
            key: "conv",
            tdCustomFunction: CommaValue,
            tooltipText: "Lead is closed and product purchased",
        },
        {
            name: "Not Conv",
            key: "notconv",
            tdCustomFunction: CommaValue,
            tooltipText: "Lead is closed and product not purchased",
        },
        {
            name: "Expired",
            key: "expired",
            tdCustomFunction: CommaValue,
            //tooltipText: "Lead is closed and product not purchased",
        },
    ];
    var ftmFinalList = useSelector(function (state) { return state.NRDashboard.NRData.reducersData.nrDataEntity; });
    var upcomingEvents = useSelector(function (state) { return state.SalesHome.upcomingEvents.reducersData.upcomingEventsEntity; });
    var upcomingMeetings = useSelector(function (state) { return state.SalesHome.upcomingMeetings.reducersData.data; });
    var expiringLeads = useSelector(function (state) { return state.SalesHome.expiringLeads.reducersData; });
    var engagementDashboard = useSelector(function (state) { return state.SalesHome.engagementDashboard.reducersData; });
    var engagementDashboardCommon = useSelector(function (state) { return state.SalesHome.engagementDashboard.commonData; });
    var engagementDashboardStausCommon = useSelector(function (state) { return state.SalesHome.engagementDashboardStatus.commonData; });
    var ftmCommonNR = useSelector(function (state) { return state.NRDashboard.NRData.commonData; });
    var engagementDashboardStatus = useSelector(function (state) { return state.SalesHome.engagementDashboardStatus.reducersData; });
    var creaticalActivity = useSelector(function (state) { return state.Profile.CreaticalActivityReducer.data; });
    var getUpcomingEvents = function () {
        var req = {
            eventName: "birthday",
            pageno: "1",
            recordcount: "100",
        };
        di.home.getUpcomingEvents(req);
    };
    var getUpcomingMeetings = function () {
        var req = {
            pageno: "1",
            recordcount: "100",
        };
        di.home.getUpcomingMeetings(req);
    };
    var getExpiringLeads = function () {
        var req = {
            page: "1",
            pageSize: "1000",
        };
        di.home.getExpiringLeads(req);
    };
    var getCriticalActivity = function () {
        profileDi.profile.getCreaticalActivity();
    };
    var getPrefernce = function () {
        profileDi.profile
            .getPreference()
            .then(function (resp) {
            if (!!resp.preferenceid && resp.preferenceid) {
                setPipelineSummarySelectedItem(function (pipelineSummarySelectedItem) {
                    if (pipelineSummaryItemList && (pipelineSummaryItemList === null || pipelineSummaryItemList === void 0 ? void 0 : pipelineSummaryItemList.length) > 0) {
                        pipelineSummaryItemList.map(function (record) {
                            if (record.value === resp.preferenceid.toString()) {
                                pipelineSummarySelectedItem = record;
                            }
                        });
                    }
                    return pipelineSummarySelectedItem;
                });
            }
        })
            .catch(function (error) { });
    };
    var savePreference = function (preferenceid) {
        profileDi.profile
            .savePreference({
            preferenceid: preferenceid,
        })
            .then(function (resp) {
            if (resp && resp.preferenceid)
                getPrefernce();
        });
    };
    var getEnagements = function (paramsFilterState) {
        var req = {
            filterData: paramsFilterState !== null && paramsFilterState !== undefined
                ? paramsFilterState
                : finalFilterState,
            page: "1",
            pageSize: "1000",
        };
        di.home.getEngagementDashboard(req);
    };
    var downloadLeadsData = function () {
        setDownloadLeadsLoader(true);
        var req = {
            filterData: finalFilterState,
        };
        di.home
            .getDownloadLeadData(req)
            .then(function (response) {
            base64toExcel(response.downloadBase64String, "Leads_Data_" + getDateInFormat(new Date(), "DD_MM_YYYY") + ".xlsx");
            setDownloadLeadsLoader(false);
        })
            .catch(function () {
            setDownloadLeadsLoader(false);
        });
    };
    var downloadEngagementData = function () {
        setDownloadEngagementLoader(true);
        var req = {
            filterData: finalFilterState,
        };
        di.home
            .getDownloadEngagementData(req)
            .then(function (response) {
            base64toExcel(response.downloadBase64String, "Engagement_Data_" + getDateInFormat(new Date(), "DD_MM_YYYY") + ".xlsx");
            setDownloadEngagementLoader(false);
        })
            .catch(function (err) {
            setDownloadEngagementLoader(false);
        });
    };
    var downloadNRData = function () {
        setDownloadNRLoader(true);
        var localFinalFilterState = JSON.parse(JSON.stringify(finalFilterState));
        localFinalFilterState.pipelineView =
            pipelineSummarySelectedItem.value == ERoleID.Client
                ? "client"
                : pipelineSummarySelectedItem.value == ERoleID.Partner
                    ? "partner"
                    : pipelineSummarySelectedItem.value == ERoleID.ClientANDPartner
                        ? "clientpartner"
                        : "";
        var req = {
            filterData: localFinalFilterState,
        };
        di.home
            .getDownloadNRData(req)
            .then(function (response) {
            base64toExcel(response.downloadBase64String, "NR_Data_" + getDateInFormat(new Date(), "DD_MM_YYYY") + ".xlsx");
            setDownloadNRLoader(false);
        })
            .catch(function () {
            setDownloadNRLoader(false);
        });
    };
    var getEnagementsStatus = function (paramsFilterState) {
        var req = {
            filterData: paramsFilterState !== null && paramsFilterState !== undefined
                ? paramsFilterState
                : finalFilterState,
            page: "1",
            pageSize: "1000",
        };
        di.home.getEngagementDashboardStatus(req);
    };
    var getNRData = function (selected, localStartDate, localEndDate, localFilterState) {
        var fromdate, todate;
        fromdate =
            localStartDate !== null && localStartDate !== undefined && localStartDate !== ""
                ? localStartDate
                : finalFilterState.fromDate !== null &&
                    finalFilterState.fromDate !== undefined &&
                    finalFilterState.fromDate !== ""
                    ? finalFilterState.fromDate
                    : moment().startOf("month").format("YYYY/MM/DD");
        todate =
            localEndDate !== null && localEndDate !== undefined && localEndDate !== ""
                ? localEndDate
                : finalFilterState.toDate !== null &&
                    finalFilterState.toDate !== undefined &&
                    finalFilterState.toDate !== ""
                    ? finalFilterState.toDate
                    : moment().endOf("month").format("YYYY/MM/DD");
        // if (selected !== null && selected !== undefined) {
        //   switch (selected.value) {
        //     case "FTM":
        //       fromdate = moment().startOf("month").format("YYYY/MM/DD");
        //       todate = moment().endOf("month").format("YYYY/MM/DD");
        //       //console.log("FLMfrom",fromdate)
        //       //console.log("FLMto",todate)
        //       break;
        //     case "FLM":
        //       fromdate = moment()
        //         .subtract(1, "month")
        //         .startOf("month")
        //         .format("YYYY/MM/DD");
        //       todate = moment()
        //         .subtract(1, "month")
        //         .endOf("month")
        //         .format("YYYY/MM/DD");
        //       //console.log("FLMfrom",fromdate)
        //       //console.log("FLMto",todate)
        //       break;
        //     case "FTY":
        //       if (moment().month() + 1 <= 3) {
        //         fromdate = moment().year() - 1 + "-04-01";
        //         todate = moment().year() + "-03-31";
        //       } else {
        //         fromdate = moment().year() + "-04-01";
        //         todate = moment().year() + 1 + "-03-31";
        //       }
        //       break;
        //   }
        // } else {
        //   fromdate =
        //     localStartDate !== null &&
        //     localStartDate !== undefined &&
        //     localStartDate !== ""
        //       ? localStartDate
        //       : moment().startOf("month").format("YYYY/MM/DD");
        //   todate =
        //     localEndDate !== null &&
        //     localEndDate !== undefined &&
        //     localEndDate !== ""
        //       ? localEndDate
        //       : moment().endOf("month").format("YYYY/MM/DD");
        // }
        var req = {
            filterData: __assign(__assign({}, (localFilterState ? localFilterState : finalFilterState)), { fromDate: fromdate, toDate: todate }),
            page: "1",
            pageSize: "1000",
        };
        nrdi.nrDashboard.getNRData(req);
    };
    var getPreferencesData = function () {
        filteDi.filter
            .getPreferencesData()
            .then(function (resp) {
            setPipelineSummaryItemList(function (pipelineSummaryItemList) {
                var _a;
                if (resp && ((_a = resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    pipelineSummaryItemList = resp.data.map(function (record) {
                        var _a;
                        return {
                            title: record.name,
                            value: (_a = record.id) === null || _a === void 0 ? void 0 : _a.toString(),
                        };
                    });
                    profileDi.profile
                        .getPreference()
                        .then(function (resp1) {
                        if (resp1 && resp1.preferenceid !== null && resp1.preferenceid !== undefined) {
                            setPipelineSummarySelectedItem(function (pipelineSummarySelectedItem) {
                                var _a;
                                if (resp && ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                    resp.data.map(function (item) {
                                        var _a;
                                        if (item.id === resp1.preferenceid) {
                                            pipelineSummarySelectedItem = {
                                                title: item.name,
                                                value: (_a = item.id) === null || _a === void 0 ? void 0 : _a.toString(),
                                            };
                                        }
                                    });
                                }
                                return pipelineSummarySelectedItem;
                            });
                        }
                    })
                        .catch(function (error) {
                        pipelineSummaryItemList = resp.data.map(function (record) {
                            var _a;
                            return {
                                title: record.name,
                                value: (_a = record.id) === null || _a === void 0 ? void 0 : _a.toString(),
                            };
                        });
                    });
                }
                return pipelineSummaryItemList;
            });
        })
            .catch(function (error) {
            setPipelineSummaryItemList([]);
        });
    };
    React.useEffect(function () {
        if (init && finalFilterState.fromDate) {
            setInit(false);
            // getUpcomingEvents();
            // getEnagementsStatus();
            getUpcomingMeetings();
            // getExpiringLeads();
            // getEnagements();
            // getNRData(dropDownNRSelected);
            getCriticalActivity();
        }
    }, [finalFilterState]);
    React.useEffect(function () {
        if (toggleCheck)
            getSummarizedData();
        else
            setSummarizedData([]);
    }, [toggleCheck, ftmFinalList]);
    React.useEffect(function () {
        if (selectedTab === ETableTabs.Meeting_Summary && init && finalFilterState.fromDate)
            getEnagements();
    }, [finalFilterState]);
    useImperativeHandle(ref, function () { return ({
        submitFilter: function () {
            getSpecificTabData(selectedTab, undefined, dropDownNRSelected);
        },
        resetFilter: function (finalFilterState) {
            setInit(true);
            getSpecificTabData(selectedTab, finalFilterState, dropDownNRSelected);
        },
        dateChangedFilter: function (localFinalFilterState, localStartDate, localEndDate) {
            getSpecificTabData(selectedTab, localFinalFilterState, null, localStartDate, localEndDate);
        },
    }); });
    var getSummarizedData = function () {
        var _a;
        var list = [];
        (_a = ftmFinalList === null || ftmFinalList === void 0 ? void 0 : ftmFinalList.nrDataList) === null || _a === void 0 ? void 0 : _a.map(function (ftm) {
            var nrDataSubList = [];
            var temp = JSON.parse(JSON.stringify(ftm));
            ftm.data.map(function (record) {
                var tempSubRecord = JSON.parse(JSON.stringify(record));
                if (record.realised !== 0)
                    tempSubRecord.realised = summarize(record.realised);
                if (record.pipeline !== 0)
                    tempSubRecord.pipeline = summarize(record.pipeline);
                if (record.order !== 0)
                    tempSubRecord.order = summarize(record.order);
                if (record.inprocess !== 0)
                    tempSubRecord.inprocess = summarize(record.inprocess);
                if (record.notConverted !== 0)
                    tempSubRecord.notConverted = summarize(record.notConverted);
                if (record.expired !== 0)
                    tempSubRecord.expired = summarize(record.expired);
                if (record.partnerPipeline !== 0)
                    tempSubRecord.partnerPipeline = summarize(record.partnerPipeline);
                if (record.partnerInProcess !== 0)
                    tempSubRecord.partnerInProcess = summarize(record.partnerInProcess);
                if (record.remainingPartnerPipeline !== 0)
                    tempSubRecord.remainingPartnerPipeline = summarize(record.remainingPartnerPipeline);
                if (record.partnerNotConverted !== 0)
                    tempSubRecord.partnerNotConverted = summarize(record.partnerNotConverted);
                if (record.partnerConveted !== 0)
                    tempSubRecord.partnerConveted = summarize(record.partnerConveted);
                if (record.totalPipeline !== 0)
                    tempSubRecord.totalPipeline = summarize(record.totalPipeline);
                nrDataSubList.push(tempSubRecord);
            });
            temp.data = nrDataSubList;
            if (ftm.realised !== 0)
                temp.realised = summarize(ftm.realised);
            if (ftm.pipeline !== 0)
                temp.pipeline = summarize(ftm.pipeline);
            if (ftm.order !== 0)
                temp.order = summarize(ftm.order);
            if (ftm.inprocess !== 0)
                temp.inprocess = summarize(ftm.inprocess);
            if (ftm.notConverted !== 0)
                temp.notConverted = summarize(ftm.notConverted);
            if (ftm.expired !== 0)
                temp.expired = summarize(ftm.expired);
            if (ftm.partnerPipeline !== 0)
                temp.partnerPipeline = summarize(ftm.partnerPipeline);
            if (ftm.remainingPartnerPipeline !== 0)
                temp.remainingPartnerPipeline = summarize(ftm.remainingPartnerPipeline);
            if (ftm.partnerInProcess !== 0)
                temp.partnerInProcess = summarize(ftm.partnerInProcess);
            if (ftm.partnerNotConverted !== 0)
                temp.partnerNotConverted = summarize(ftm.partnerNotConverted);
            if (ftm.partnerConveted !== 0)
                temp.partnerConveted = summarize(ftm.partnerConveted);
            if (ftm.totalPipeline !== 0)
                temp.totalPipeline = summarize(ftm.totalPipeline);
            list.push(temp);
        });
        setSummarizedData(list);
    };
    var NRTotalDataUI = function () {
        var _a;
        return (React.createElement(React.Fragment, null, (ftmFinalList === null || ftmFinalList === void 0 ? void 0 : ftmFinalList.totalDataLst) && ((_a = ftmFinalList.totalDataLst) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(React.Fragment, null, ftmFinalList.totalDataLst
            .filter(function (record) {
            var totalColumns = [];
            if ((pipelineSummarySelectedItem === null || pipelineSummarySelectedItem === void 0 ? void 0 : pipelineSummarySelectedItem.value) == ERoleID.Client) {
                totalColumns = [
                    EPipelineSummaryColumns.ClientTotal,
                    EPipelineSummaryColumns.InprocessPipeline,
                    EPipelineSummaryColumns.Expired,
                    EPipelineSummaryColumns.ConvertedPipeline,
                    EPipelineSummaryColumns.NotConvertedPipeline,
                    EPipelineSummaryColumns.OrderValue,
                ];
                return totalColumns.includes(record === null || record === void 0 ? void 0 : record.columnName);
            }
            else if ((pipelineSummarySelectedItem === null || pipelineSummarySelectedItem === void 0 ? void 0 : pipelineSummarySelectedItem.value) == ERoleID.Partner) {
                totalColumns = [
                    EPipelineSummaryColumns.Partner,
                    EPipelineSummaryColumns.Remaining,
                    EPipelineSummaryColumns.NotConverted,
                ];
                return totalColumns.includes(record === null || record === void 0 ? void 0 : record.columnName);
            }
            else {
                return record.columnName;
            }
        })
            .map(function (record, id) {
            var _a;
            return (React.createElement("td", { key: id, className: "txt-midnight-blue" },
                React.createElement("span", null,
                    React.createElement(ReportValue, { val: toggleCheck ? summarize(record.totalDataKey) : record.totalDataKey, stream: false, onlyval: false, withoutDigit: true, showZero: false, showSummarize: toggleCheck }),
                    " ",
                    record.totalClientDataKey !== undefined &&
                        record.totalClientDataKey !== null &&
                        ((_a = record.totalClientDataKey) === null || _a === void 0 ? void 0 : _a.toString()) !== "0" && (React.createElement(React.Fragment, null,
                        "(",
                        React.createElement(ReportValue, { val: toggleCheck
                                ? summarize(record.totalClientDataKey)
                                : record.totalClientDataKey, stream: false, onlyval: false, withoutDigit: true, showZero: false, showSummarize: toggleCheck }),
                        ")")))));
        })))));
    };
    var handleTabChange = function (selectedTab) {
        setSelectedTab(selectedTab);
        getSpecificTabData(selectedTab, undefined, dropDownNRSelected, "", "");
    };
    var getSpecificTabData = function (currentTab, filtersState, dropDown, startDate, endDate) {
        switch (currentTab) {
            case ETableTabs.Meeting_Summary:
                getEnagements(filtersState);
                break;
            case ETableTabs.Lead_Summary:
                getEnagementsStatus(filtersState);
                break;
            case ETableTabs.Revenue_Summary:
                getPreferencesData();
                getNRData(dropDown, startDate, endDate, filtersState);
                break;
        }
    };
    var tableTabs = [
        {
            title: "Meeting Summary",
            tabContent: (React.createElement(SaleProcessTable, { Loader: engagementDashboardCommon.loader, errorData: engagementDashboardCommon.errorData, columnsList: engagementColumn, totolData: (_b = engagementDashboard === null || engagementDashboard === void 0 ? void 0 : engagementDashboard.engagementEntity) === null || _b === void 0 ? void 0 : _b.totalOfData, tbodyData: engagementDashboard.engagementEntity.data, downloadFunction: downloadEngagementData, toggleCheck: false, downloadloader: downloadEngagementLoader, tfootColored: true })),
            eventKey: ETableTabs.Meeting_Summary,
        },
        {
            title: "Lead Summary",
            tabContent: (React.createElement(SaleProcessTable, { Loader: engagementDashboardStausCommon.loader, errorData: engagementDashboardStausCommon.errorData, columnsList: leadColumn, totolData: (_c = engagementDashboardStatus === null || engagementDashboardStatus === void 0 ? void 0 : engagementDashboardStatus.engagementStatusEntity) === null || _c === void 0 ? void 0 : _c.totalOfData, tbodyData: engagementDashboardStatus.engagementStatusEntity.data, downloadFunction: downloadLeadsData, toggleCheck: false, parentClass: "lead-summary-table", downloadloader: downloadLeadsLoader })),
            eventKey: ETableTabs.Lead_Summary,
        },
        {
            title: "Pipeline Summary",
            tabContent: (React.createElement(SaleProcessTable, { Loader: ftmCommonNR === null || ftmCommonNR === void 0 ? void 0 : ftmCommonNR.loader, errorData: ftmCommonNR === null || ftmCommonNR === void 0 ? void 0 : ftmCommonNR.errorData, columnsList: ftmColumn, totolData: ftmFinalList === null || ftmFinalList === void 0 ? void 0 : ftmFinalList.totalData, tbodyData: summarizedData && summarizedData.length > 0 && toggleCheck
                    ? summarizedData
                    : ftmFinalList.nrDataList, tfootColored: true, summarize: true, 
                //tFooterData={totalFooter}
                parentClass: "remove-border", downloadFunction: downloadNRData, showClientCount: true, toggleCheck: toggleCheck, totalDataUI: NRTotalDataUI, setToggleCheck: setToggleCheck, downloadloader: downloadNRLoader, allowedClick: true, isNRSummary: true, isRM: loginDI.login.getIsRMPartnerFRM().isRM, showDataFor: pipelineSummarySelectedItem.value, headComp: React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "View"),
                    React.createElement(GenericDropdown, { align: "end", 
                        // disabled
                        id: "", externalClassname: "client-dropdown pipeline-summary-dropdown", defaultVal: true, selectedDefaultVal: pipelineSummarySelectedItem, callUseEffect: true, defaultText: "select", itemlist: pipelineSummaryItemList, selectedValue: function (e) {
                            setPipelineSummarySelectedItem(e);
                            savePreference(Number(e.value));
                        } })) })),
            eventKey: ETableTabs.Revenue_Summary,
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericTabs, { key: selectedTab, defaultActiveKey: selectedTab, tabsArray: tableTabs, externalClassName: "home-tab-table-container w-100", callBackFunction: handleTabChange }),
        React.createElement(Row, { className: "mb-5" },
            React.createElement(Col, { lg: 6, md: 6 },
                React.createElement("div", null,
                    React.createElement(UpcomingActivities, { events: upcomingEvents.upcomingEventsList, totalExpiringLeads: ((_d = expiringLeads.expiringLeads) === null || _d === void 0 ? void 0 : _d.totalitems) !== null &&
                            ((_e = expiringLeads.expiringLeads) === null || _e === void 0 ? void 0 : _e.totalitems) !== undefined &&
                            ((_f = expiringLeads.expiringLeads) === null || _f === void 0 ? void 0 : _f.totalitems) !== "" &&
                            Number((_g = expiringLeads.expiringLeads) === null || _g === void 0 ? void 0 : _g.totalitems) > 0
                            ? ((_h = expiringLeads.expiringLeads) === null || _h === void 0 ? void 0 : _h.totalitems) !== null &&
                                ((_j = expiringLeads.expiringLeads) === null || _j === void 0 ? void 0 : _j.totalitems) !== undefined &&
                                ((_k = expiringLeads.expiringLeads) === null || _k === void 0 ? void 0 : _k.totalitems) !== "" &&
                                Number((_l = expiringLeads.expiringLeads) === null || _l === void 0 ? void 0 : _l.totalitems).toString()
                            : "", upcomingMeetings: upcomingMeetings }))),
            React.createElement(Col, { lg: 6, md: 6 },
                React.createElement("div", { className: "critical-activity-parent" },
                    React.createElement(CriticalActivities, { criticalActivities: creaticalActivity.data })))))
    // <>
    //   <Row className="pb-1 mb-4 engagements-leads-block">
    //     <Col>
    //       <SaleProcessTable
    //         headComp={
    //           <label className="DMSansMedium_20_500 txt-midnight-blue">
    //             Meeting Summary
    //           </label>
    //         }
    //         Loader={engagementDashboardCommon.loader}
    //         errorData={engagementDashboardCommon.errorData}
    //         columnsList={engagementColumn}
    //         totolData={engagementDashboard?.engagementEntity?.totalOfData}
    //         tbodyData={engagementDashboard.engagementEntity.data}
    //         downloadFunction={downloadEngagementData}
    //         toggleCheck={false}
    //         downloadloader={downloadEngagementLoader}
    //       />
    //     </Col>
    //     <Col>
    //       <SaleProcessTable
    //         headComp={
    //           <label className="DMSansMedium_20_500 txt-midnight-blue">
    //             Leads Summary
    //           </label>
    //         }
    //         Loader={engagementDashboardStausCommon.loader}
    //         errorData={engagementDashboardStausCommon.errorData}
    //         columnsList={leadColumn}
    //         totolData={
    //           engagementDashboardStatus?.engagementStatusEntity?.totalOfData
    //         }
    //         tbodyData={engagementDashboardStatus.engagementStatusEntity.data}
    //         downloadFunction={downloadLeadsData}
    //         toggleCheck={false}
    //         parentClass="lead-summary-table"
    //         downloadloader={downloadLeadsLoader}
    //       />
    //     </Col>
    //   </Row>
    //   <Row className="mb-5">
    //     <Col lg={12} md={12}>
    //       <SaleProcessTable
    //         headComp={
    //           <></>
    //           // <EquityDropdown
    //           //   externalClassname="sales-dropdown home-sales-table"
    //           //   itemlist={dropDownList}
    //           //   defaultVal={true}
    //           //   selectedValue={(selected: items) => {
    //           //     setDropDownNRSelected(selected);
    //           //     getNRData(selected);
    //           //   }}
    //           // />
    //         }
    //         Loader={ftmCommonNR?.loader}
    //         errorData={ftmCommonNR?.errorData}
    //         columnsList={ftmColumn}
    //         totolData={ftmFinalList?.totalData}
    //         tbodyData={
    //           summarizedData && summarizedData.length > 0 && toggleCheck
    //             ? summarizedData
    //             : ftmFinalList.nrDataList
    //         }
    //         tfootColored
    //         summarize
    //         //tFooterData={totalFooter}
    //         parentClass="remove-border"
    //         downloadFunction={downloadNRData}
    //         showClientCount={true}
    //         toggleCheck={toggleCheck}
    //         totalDataUI={NRTotalDataUI}
    //         setToggleCheck={setToggleCheck}
    //         downloadloader={downloadNRLoader}
    //       />
    //     </Col>
    //   </Row>
    //   <Row className="mb-5">
    //     <Col lg={6} md={6}>
    //       <div>
    //         <UpcomingActivities
    //           events={upcomingEvents.upcomingEventsList}
    //           totalExpiringLeads={
    //             expiringLeads.expiringLeads?.totalitems !== null &&
    //             expiringLeads.expiringLeads?.totalitems !== undefined &&
    //             expiringLeads.expiringLeads?.totalitems !== "" &&
    //             Number(expiringLeads.expiringLeads?.totalitems) > 0
    //               ? expiringLeads.expiringLeads?.totalitems !== null &&
    //                 expiringLeads.expiringLeads?.totalitems !== undefined &&
    //                 expiringLeads.expiringLeads?.totalitems !== "" &&
    //                 Number(expiringLeads.expiringLeads?.totalitems).toString()
    //               : ""
    //           }
    //           upcomingMeetings={upcomingMeetings}
    //         />
    //       </div>
    //     </Col>
    //     <Col lg={6} md={6}>
    //       <div>
    //         <CriticalActivities criticalActivities={creaticalActivity.data} />
    //       </div>
    //     </Col>
    //   </Row>
    // </>
    );
});
export default HomeSalesTable;
